import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import { paths } from "./constants";
import reportIcon from "../assets/report.png";
const iconStyle = { width: "25px", height: "25px" };

const ReportMenuIcon = <img src={reportIcon} alt="report" />;

export const metricsDashboardItem = {
  path: paths.METRICS_DASHBOARD,
  name: "Metrics Dashboard",
  icon: ReportMenuIcon,
  submenus: [
    { path: paths.METRICS_CORE_ENGAGEMENT, name: "Core Engagement", isSeparator: false },
    { path: paths.METRICS_AI_GENERATION, name: "AI Generation", isSeparator: false },
    { path: paths.METRICS_CONTENT_ENGAGEMENT, name: "Content & Engagement", isSeparator: false, disabled: true },
    { path: paths.METRICS_CREATOR_ANALYTICS, name: "Creator Analytics", isSeparator: false, disabled: true },
    { path: paths.METRICS_SUBSCRIPTION_REVENUE, name: "Subscription & Revenue", isSeparator: false },
    { path: paths.METRICS_WALLET_REWARDS, name: "Wallet & Rewards", isSeparator: false },
    { path: paths.METRICS_AUTH_ONBOARDING, name: "Authentication & Onboarding", isSeparator: false, disabled: true },
    { path: paths.METRICS_NOTIFICATIONS_REENGAGEMENT, name: "Notifications & Re-engagement", isSeparator: false, disabled: true },
  ],
};

export const eventsItem = {
  path: paths.EVENTS,
  name: "Events",
  icon: ReportMenuIcon,
  submenus: [
    { path: paths.EVENTS_USER_LIFECYCLE, name: "User Lifecycle", isSeparator: false },
    { path: paths.EVENTS_AUTH_ONBOARDING, name: "Authentication & Onboarding", isSeparator: false },
    { path: paths.EVENTS_AI_GENERATION, name: "AI Generation", isSeparator: false },
    { path: paths.EVENTS_AI_TOOL_ACTIONS, name: "AI Tool Actions", isSeparator: false },
    { path: paths.EVENTS_AI_TOOLS, name: "AI Tools", isSeparator: false },
    { path: paths.EVENTS_CONTENT, name: "Content", isSeparator: false },
    { path: paths.EVENTS_CONTENT_ENGAGEMENT, name: "Content Engagement", isSeparator: false },
    { path: paths.EVENTS_CREATOR, name: "Creator", isSeparator: false },
    { path: paths.EVENTS_DISCOVERY, name: "Discovery", isSeparator: false },
    { path: paths.EVENTS_SEARCH, name: "Search", isSeparator: false },
    { path: paths.EVENTS_EDIT_SUITE, name: "Edit Suite", isSeparator: false },
    { path: paths.EVENTS_SUBSCRIPTION_REVENUE, name: "Subscription & Revenue", isSeparator: false },
    { path: paths.EVENTS_WALLET_REWARDS, name: "Wallet & Rewards", isSeparator: false },
    { path: paths.EVENTS_NOTIFICATIONS, name: "Notifications", isSeparator: false },
    { path: paths.EVENTS_SETTINGS_PROFILE, name: "Settings & Profile", isSeparator: false },
    { path: paths.EVENTS_DEVICE_PLATFORM, name: "Device & Platform", isSeparator: false },
    { path: paths.EVENTS_DASHBOARD_NAVIGATION, name: "Dashboard Navigation", isSeparator: false },
    { path: paths.EVENTS_TOOL_WISE, name: "Tool-wise", isSeparator: false },
    { path: paths.EVENTS_OTHER_NAVIGATION, name: "Other / Navigation", isSeparator: false },
  ],
};

export const menuItems = [
  metricsDashboardItem,
  // {
  //   path: paths.DASHBOARD,
  //   name: "Dashboard",
  //   icon: ReportMenuIcon,
  //   submenus: [],
  // },

  // eventsItem,

  {
    path: paths.CATALOG_MANAGEMENT,
    name: "Catalog",
    icon: <VideoLibraryOutlinedIcon style={iconStyle} />,
    submenus: [
      {
        path: paths.CATALOG_MANAGEMENT,
        name: "All Catalog",
      },

      {
        path: paths.CATALOG_MANAGEMENT_RAILS,
        name: "Rails",
      },
      {
        path: paths.CATALOG_MANAGEMENT_DISPLAYTYPE,
        name: "Display Type",
      },
    ],
  },
  {
    path: paths.CONTENTS,
    name: "Content Hub",
    icon: <PlayCircleOutlineIcon style={iconStyle} />,
    submenus: [
      {
        path: paths.CONTENTS,
        name: "All Video",
      },
      {
        path: paths.CP_CONTENTS,
        name: " All Asset",
      },
      {
        path: paths.CONTENT_TAG,
        name: "Tags",
      },
      {
        path: paths.MANAGE_TRANS,
        name: "Manage Transcode",
      },
      {
        path: paths.BULK_UPLOAD,
        name: "Bulk Upload",
      },
      {
        path: "",
        name: "",
        isSeparator: true,
      },
      {
        path: paths.PRESETS,
        name: "Video Presets",
      },
      {
        path: paths.IMAGE_PRESET,
        name: "Image Presets",
      },
      {
        path: "",
        name: "",
        isSeparator: true,
      },
      {
        path: paths.CONTENT_TYPES,
        name: "Content Type",
      },
      {
        path: paths.CONTENT_SUBTYPE,
        name: "Content Sub Type",
      },
      // {
      //   path: paths.EXTERNAL_PLAYER,
      //   name: "External Player",
      // },
      {
        path: paths.CONTENT_PARENTALRATING,
        name: "Parental Rating",
      },
      {
        path: paths.CONTENT_FILTER,
        name: "Filter Tag",
      },
      {
        path: paths.CONTENT_GENRE,
        name: "Genre",
      },
      {
        path: paths.CONTENT_KEYWORD,
        name: "Keyword",
      },

      {
        path: paths.PARTNER,
        name: "Partner",
      },
      {
        path: paths.PRODUCTION_HOUSE,
        name: "Production House",
      },
      // {
      //   path: paths.STUDIO,
      //   name: "Studio",
      // },
      {
        path: paths.ADINFO,
        name: "Ad Info",
      },
    ],
  },
  {
    path: paths.MENU_GROUP,
    name: "Menu Builder",
    icon: <MenuOutlinedIcon style={iconStyle} />,
    submenus: [
      {
        path: paths.MENU_GROUP,
        name: "All Menu",
      },
      {
        path: paths.MENU,
        name: "Standalone Item",
      },
      {
        path: paths.SUBMENU,
        name: "Submenu Item",
      },
      {
        path: paths.MENU_ITEM,
        name: "Menu Item",
      },
    ],
  },
  {
    path: paths.INFO,
    name: "Static Info Hub",
    icon: <InfoOutlinedIcon style={iconStyle} />,
    submenus: [
      {
        path: paths.BUSINESSUNIT,
        name: "Business unit",
      },
      {
        path: paths.INFO_CONFIG,
        name: "Configuration",
      },
      {
        path: paths.INFO,
        name: "Country",
      },

      {
        path: paths.INFO_DEVICES,
        name: "Devices",
      },
      {
        path: paths.INFO_LANGUAGES,
        name: "Languages",
      },

      {
        path: paths.LOCALLANGUAGE,
        name: "App Display language",
      },
    ],
  },
  {
    path: paths.USER_PROFILE,
    name: "Administration",
    icon: <AdminPanelSettingsOutlinedIcon style={iconStyle} />,
    submenus: [
      {
        path: paths.USER_PROFILE,
        name: "Users",
      },
      {
        path: paths.CREATE_ROLE,
        name: "Roles",
      },
    ],
  },
  {
    path: paths.SETTINGS,
    name: "Settings",
    icon: <SettingsIcon style={iconStyle} />,
    submenus: [
      {
        path: paths.SETTINGS,
        name: "Social Connect",
      },
    ],
  },
];

export const cpMenuItems = [
  metricsDashboardItem,
  /*
  {
    path: paths.DASHBOARD,
    name: "Dashboard",
    icon: ReportMenuIcon,
    submenus: [],
  },
  eventsItem,
  */
  {
    path: paths.CATALOG_MANAGEMENT,
    name: "Catalog",
    icon: <VideoLibraryOutlinedIcon style={iconStyle} />,
    submenus: [
      {
        path: paths.CATALOG_MANAGEMENT_RAILS,
        name: "Rails",
      },
      {
        path: paths.CATALOG_MANAGEMENT_DISPLAYTYPE,
        name: "Display Type",
      },
    ],
  },
  {
    path: paths.CONTENTS,
    name: "Content Hub",
    icon: <PlayCircleOutlineIcon style={iconStyle} />,
    submenus: [
      // {
      //   path: paths.CONTENTS,
      //   name: "All Video",
      // },
      {
        path: paths.CP_CONTENTS,
        name: " All Asset",
      },
      {
        path: paths.CONTENT_TAG,
        name: "Tags",
      },
      {
        path: paths.MANAGE_TRANS,
        name: "Manage Transcode",
      },
      {
        path: paths.BULK_UPLOAD,
        name: "Bulk Upload",
      },
      {
        path: "",
        name: "",
        isSeparator: true,
      },
      {
        path: paths.PRESETS,
        name: "Video Presets",
      },
      {
        path: paths.IMAGE_PRESET,
        name: "Image Presets",
      },
      {
        path: "",
        name: "",
        isSeparator: true,
      },
      // {
      //   path: paths.CONTENT_TYPES,
      //   name: "Content Type",
      // },
      // {
      //   path: paths.CONTENT_SUBTYPE,
      //   name: "Content Sub Type",
      // },
      // {
      //   path: paths.EXTERNAL_PLAYER,
      //   name: "External Player",
      // },
      // {
      //   path: paths.CONTENT_PARENTALRATING,
      //   name: "Parental Rating",
      // },
      // {
      //   path: paths.CONTENT_FILTER,
      //   name: "Filter Tag",
      // },
      // {
      //   path: paths.CONTENT_GENRE,
      //   name: "Genre",
      // },
      // {
      //   path: paths.CONTENT_KEYWORD,
      //   name: "Keyword",
      // },

      // {
      //   path: paths.PARTNER,
      //   name: "Partner",
      // },
      // {
      //   path: paths.PRODUCTION_HOUSE,
      //   name: "Production House",
      // },
      // {
      //   path: paths.STUDIO,
      //   name: "Studio",
      // },
      // {
      //   path: paths.CURRENT_PLAYER,
      //   name: "Player",
      // },
      {
        path: paths.ADINFO,
        name: "Ad Info",
      },
    ],
  },
  {
    path: paths.USER_PROFILE,
    name: "Administration",
    icon: <AdminPanelSettingsOutlinedIcon style={iconStyle} />,
    submenus: [
      {
        path: paths.USER_PROFILE,
        name: "Users",
      },
      {
        path: paths.CREATE_ROLE,
        name: "Roles",
      },
    ],
  },
  {
    path: paths.SETTINGS,
    name: "Settings",
    icon: <SettingsIcon style={iconStyle} />,
    submenus: [
      {
        path: paths.SETTINGS,
        name: "Social Connect",
      },
    ],
  },
];

export const getMenuItems = (isOTTPlatform: boolean) => [
  metricsDashboardItem,
  // {
  //   path: paths.DASHBOARD,
  //   name: "Dashboard",
  //   icon: ReportMenuIcon,
  //   submenus: [
  //     { path: paths.DASHBOARD, name: "Overview", isSeparator: false },
  //     { path: paths.GRAPH_DASHBOARD, name: "Platform & Device", isSeparator: false },
  //     { path: paths.CONTENT_DASHBOARD, name: "Content Analytics", isSeparator: false },
  //     { path: paths.GEOGRAPHIC_DASHBOARD, name: "Geographic Distribution", isSeparator: false },
  //     { path: paths.USER_DATA_DASHBOARD, name: "User Data", isSeparator: false },
  //     { path: paths.USER_ACTIVITY_DASHBOARD, name: "User Activity", isSeparator: false },
  //     { path: paths.PLAYBACK_ANALYTICS, name: "Playback Analytics", isSeparator: false },
  //     { path: paths.DEVICE_PLATFORM_ANALYTICS, name: "DevicePlatform Analytics", isSeparator: false },
  //     { path: paths.SUBSCRIPTION_REVENUE_ANALYTICS, name: "Subscription & Revenue Analytics", isSeparator: false },
  //     { path: paths.CONTENT_ANALYTICS, name: "Content Analytics", isSeparator: false },
  //     // { path: paths.UNIVERSE_ANALYTICS, name: "Universe Analytics", isSeparator: false }
  //   ],
  // },
  // eventsItem,

];
